/**
 * True when a score should be plotted under the org's current scoring config
 * version.
 *
 * Version filtering only applies when there's a known current config version to
 * compare against. When `latestConfigId` is absent — default/taxonomy orgs, or
 * any org with the `scoring_settings_data` flag off — there's no version to
 * filter on, so every score is kept. (The backend stamps each rating's config
 * id from the latest config row regardless of the flag, so a flag-off org can
 * still carry a non-null config id; without this guard those scores would be
 * wrongly dropped.)
 */
export const isOnLatestConfig = (
  configId: null | string | undefined,
  latestConfigId: null | string | undefined
): boolean => latestConfigId == null || configId === latestConfigId;
